import { CommonModule } from "@angular/common";
import { NgModule, Optional, SkipSelf } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { ChangePasswordComponent } from "@app/core/change-password/change-password.component";
import { ContactComponent } from "@app/core/contact/contact.component";
import { CookieComponent } from "@app/core/cookie/cookie.component";
import { CoreRouterModule } from "@app/core/core.routing";
import { FooterComponent } from "@app/core/footer/footer.component";
import { HeaderComponent } from "@app/core/header/header.component";
import { CompanyComponent } from "@app/core/home/company/company.component";
import { HomeComponent } from "@app/core/home/home.component";
import { WhySignUpComponent } from "@app/core/home/why-sign-up/why-sign-up.component";
import { MainComponent } from "@app/core/main.component";
import { PartnerComponent } from "@app/core/partner/partner.component";
import { PasswordRecoveryComponent } from "@app/core/password-recovery/password-recovery.component";
import { PaymentSuccessComponent } from "@app/core/payment-success/payment-success.component";
import { PrivacyComponent } from "@app/core/privacy/privacy.component";
import { RegistrationComponent } from "@app/core/registration/registration.component";
import { ServerMaintenanceComponent } from "@app/core/server-maintenance/server-maintenance.component";
import { SpinnerModule } from "@app/core/spinner/spinner.module";
import { UserSignupComponent } from "@app/core/user-signup/user-signup.component";
import { FormxInputComponent } from "@shared/component/formx-input/formx-input.component";
import { UsersService } from "@shared/services/users/users.service";
import { SharedModule } from "@shared/shared.module";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";

@NgModule({
	declarations: [
		PartnerComponent,
		FooterComponent,
		HeaderComponent,
		HomeComponent,
		RegistrationComponent,
		PrivacyComponent,
		MainComponent,
		PasswordRecoveryComponent,
		CookieComponent,
		ChangePasswordComponent,
		UserSignupComponent,
		CompanyComponent,
		WhySignUpComponent,
		ContactComponent,
		ServerMaintenanceComponent,
		PaymentSuccessComponent
	],
	imports: [
		CommonModule,
		SharedModule,
		CoreRouterModule,
		SpinnerModule,
		ReactiveFormsModule,
		BsDropdownModule,
		FormxInputComponent
	],
	exports: [
		SpinnerModule
	],
	providers: [
		UsersService
	],
	bootstrap: [MainComponent]
})
export class CoreModule {
	constructor(@Optional() @SkipSelf() parentModule: CoreModule) { }
}
